import React, { useEffect, useState } from "react";

import db from "../../services/query";
import { EmptyState, LoadingState } from "../common/SurfaceUI";
import Table from "../common/Table";

const LibraryProfile = (props) => {
  const { tid } = props.match.params;
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refresh = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await db.getAll(`teachers/${tid}/library`);
      setRows(data?.data || []);
    } catch (_) {
      setError("بارگیری کتاب‌های امانت‌گرفته ناموفق بود.");
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, [tid]);

  const columns = [
    { path: "id", label: "شماره" },
    { path: "name", label: "کتاب" },
    { path: "registration_no", label: "شماره ثبت" },
    { path: "author", label: "مؤلف" },
    { path: "lend_date", label: "تاریخ امانت" },
    { path: "lend_duration", label: "مدت(روز)" },
    { path: "days_left", label: "مهلت(روز)" },
    { path: "return_date", label: "تاریخ برگشت" },
    {
      key: "status",
      label: "وضعیت",
      content: (row) => (Number(row.returned) === 1 ? "برگشت شده" : "در امانت"),
    },
    { path: "fine", label: "جریمه" },
  ];

  if (loading) return <LoadingState />;
  if (error) {
    return (
      <EmptyState
        title={error}
        action={<button type="button" onClick={refresh}>بارگیری مجدد</button>}
      />
    );
  }
  if (!rows.length) {
    return <EmptyState title="کتابی به نام این استاد در امانت ثبت نشده است." />;
  }

  return (
    <div className="main-content-body">
      <Table data={rows} columns={columns} />
    </div>
  );
};

export default LibraryProfile;
